// @core/api/endpoints/document/create_pipeline.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreatePipelineRequest,
  PipelineResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Create pipeline
 * Creates a new document pipeline template with sequential stages. Each stage defines actors, action type, and completion rules.
 */
export async function CreatePipeline(
  data: CreatePipelineRequest,
  options?: RequestOptions
): Promise<PipelineResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/document-pipelines`;
  const requestOptions = options;
  return client.post<PipelineResponse>(requestPath, data, requestOptions);
}
